<mat-form-field>
  <mat-label>{{ label() }}</mat-label>
  <input
    type="text"
    [required]="required()"
    [placeholder]="placeholder()"
    [formControl]="searchControl"
    class="form-control"
    [matAutocomplete]="auto"
    [errorStateMatcher]="externalValidationStateMatcher"
    (blur)="markValidationControlAsTouched()"
    matInput />

  <mat-autocomplete
    #auto="matAutocomplete"
    hideSingleSelectionIndicator="true"
    [displayWith]="displayFn"
    (optionSelected)="onSelect($event.option.value)"
    okCustomDropDownArrowDirective>
    @let isLoading = loading();
    @let options = results();
    @if (options.length > 0 || !isLoading) {
      @for (option of options; track trackByIdentity(option)) {
        <mat-option [value]="option">
          @if (itemTemplate()) {
            <ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: option }"> </ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="defItemTemplate; context: { $implicit: option }"> </ng-container>
          }
        </mat-option>
      }
    } @else {
      <mat-option disabled>
        <span class="spinner"></span>
      </mat-option>
    }
  </mat-autocomplete>

  @let showSelectionClear = !!this.selectedItem();
  @if (searchControl.value && !showSelectionClear && disabled() === false) {
    <button
      matSuffix
      class="clear-input-field-button"
      type="button"
      (click)="clearInput(); $event.stopPropagation()"
      aria-label="Ryd indhold i feltet">
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
    </button>
  }
  @if (showSelectionClear && disabled() === false) {
    <button
      matSuffix
      class="clear-input-field-button"
      type="button"
      (click)="clearSelection(); $event.stopPropagation()"
      aria-label="Ryd indhold i feltet">
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
    </button>
  }
  <mat-icon matSuffix></mat-icon>
  @if (suffixIcon()) {
    <mat-icon matIconSuffix [matTooltip]="suffixIconTooltip() || ''">
      {{ suffixIcon() }}
    </mat-icon>
  }
  @if (hasRequiredValidationError()) {
    <mat-error>
      {{ requiredErrorText() }}
    </mat-error>
  }
</mat-form-field>

<ng-template #defItemTemplate let-item>
  {{ item?.name }}
</ng-template>
